"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    integrations: {
        path: "/settings/data/integrations",
    },
    arcGISExports: {
        path: "/settings/data/integrations/arcgis",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZWdyYXRpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vcm91dGluZy9pbnRlZ3JhdGlvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUNBQXNDO0FBRXpCLFFBQUEsTUFBTSxHQUFHLElBQUEsbUJBQVcsRUFBQztJQUNoQyxZQUFZLEVBQUU7UUFDWixJQUFJLEVBQUUsNkJBQTZCO0tBQ3BDO0lBQ0QsYUFBYSxFQUFFO1FBQ2IsSUFBSSxFQUFFLG9DQUFvQztLQUMzQztDQUNGLENBQUMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGJ1aWxkUm91dGVzIH0gZnJvbSBcIi4vdHlwZXNcIjtcblxuZXhwb3J0IGNvbnN0IHJvdXRlcyA9IGJ1aWxkUm91dGVzKHtcbiAgaW50ZWdyYXRpb25zOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvZGF0YS9pbnRlZ3JhdGlvbnNcIixcbiAgfSxcbiAgYXJjR0lTRXhwb3J0czoge1xuICAgIHBhdGg6IFwiL3NldHRpbmdzL2RhdGEvaW50ZWdyYXRpb25zL2FyY2dpc1wiLFxuICB9LFxufSk7XG4iXX0=